import Icon from '../../../components/AppIcon';
import { QuoteTotals } from '../types';

interface TotalsSectionProps {
  totals: QuoteTotals;
  licensesIncluded: boolean;
  implementationIncluded: boolean;
}

const TotalsSection = ({ totals, licensesIncluded, implementationIncluded }: TotalsSectionProps) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-sm">
      <div className="flex items-center gap-3 p-4 border-b border-border">
        <Icon name="Calculator" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-text-primary">Quote Summary</h2>
      </div>

      <div className="p-6 space-y-4">
        {licensesIncluded && (
          <div className="space-y-2">
            <div className="flex items-center justify-between py-2 border-b border-border">
              <span className="text-sm text-text-secondary">Licenses (Monthly)</span>
              <span className="font-mono text-sm text-text-primary">
                €{totals.licensesMonthly.toFixed(2)}
              </span>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-border">
              <span className="text-sm text-text-secondary">Licenses (Annual)</span>
              <span className="font-mono text-sm text-text-primary">
                €{totals.licensesAnnual.toFixed(2)}
              </span>
            </div>
          </div>
        )}

        {implementationIncluded && (
          <div className="flex items-center justify-between py-2 border-b border-border">
            <span className="text-sm text-text-secondary">Implementation Services</span>
            <span className="font-mono text-sm text-text-primary">
              €{totals.implementationTotal.toFixed(2)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalsSection;